import { SHIPOUT_STATUSES, SHIPOUT_STATUSES_SEQUENCE } from '../../constants/custom-store-shipouts.constants';
export function canShipoutBeRemoved(shipout) {
  const nonDeletebaleStatusIndex = SHIPOUT_STATUSES_SEQUENCE.indexOf(SHIPOUT_STATUSES.SHIPMENT_REQUESTED);
  return SHIPOUT_STATUSES_SEQUENCE.indexOf(shipout.status) < nonDeletebaleStatusIndex && !shipout.paidAt;
}